import React, { FC, MouseEventHandler } from 'react';
import { Icon } from '../../Icon';
require("./AddressButtonIcon.css");
var styles = {
  "Root": "AddressButtonIcon-module-Root_1d5",
  "ButtonSvg": "AddressButtonIcon-module-ButtonSvg_3r3"
};
export const AddressButtonIcon = ({
  'aria-label': ariaLabel,
  isOpen = false,
  onPointerDown
}) => {
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    onPointerDown: onPointerDown,
    className: styles.Root,
    "aria-label": ariaLabel
  }, /*#__PURE__*/React.createElement(Icon, {
    className: styles.ButtonSvg,
    name: isOpen ? 'chevronUp' : 'chevronDown',
    size: "m"
  }));
};